import React from 'react';
import { socialMedia } from '../data/mock';
import { Mail, Instagram, Facebook, Music2, Youtube } from 'lucide-react';

const ContactSection = () => {
  return (
    <section id="contact" className="py-24 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-40 left-20 w-96 h-96 bg-blue-500 rounded-full filter blur-[150px] animate-pulse"></div>
        <div className="absolute bottom-40 right-20 w-96 h-96 bg-cyan-400 rounded-full filter blur-[150px] animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div className="container mx-auto px-4 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <div className="inline-block mb-4">
            <span className="text-blue-400 text-sm font-medium uppercase tracking-widest border-b-2 border-blue-400 pb-2 flex items-center gap-2 justify-center">
              <Mail size={16} />
              Kontakt
            </span>
          </div>
          <h2 className="text-5xl md:text-6xl font-bold text-white mb-4">
            Lass uns in
            <span className="block bg-gradient-to-r from-blue-400 to-cyan-300 bg-clip-text text-transparent">
              Kontakt bleiben
            </span>
          </h2>
          <p className="text-gray-400 text-lg max-w-2xl mx-auto">
            Folge mir auf Social Media und bleib immer auf dem Laufenden! Ich freue mich auf den Austausch mit dir.
          </p>
        </div>

        {/* Social Media - Centered */}
        <div className="max-w-2xl mx-auto">
          <div className="bg-white/5 backdrop-blur-sm border border-white/10 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-white mb-4 text-center">Folge mir auf Social Media</h3>
            <p className="text-gray-400 mb-8 text-center">
              Du erreichst mich am besten über meine Social Media Kanäle. Schreib mir eine Nachricht oder markiere mich in deinen Posts!
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              <a
                href={socialMedia.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-black/50 border border-white/10 rounded-lg hover:border-pink-400 hover:bg-pink-500/10 transition-all duration-300 group"
              >
                <Instagram className="text-pink-400 group-hover:scale-110 transition-transform" size={24} />
                <div>
                  <span className="text-white font-medium block">Instagram</span>
                  <span className="text-gray-400 text-sm">@laura.sommerfeld.official</span>
                </div>
              </a>

              <a
                href={socialMedia.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-black/50 border border-white/10 rounded-lg hover:border-blue-400 hover:bg-blue-500/10 transition-all duration-300 group"
              >
                <Facebook className="text-blue-400 group-hover:scale-110 transition-transform" size={24} />
                <div>
                  <span className="text-white font-medium block">Facebook</span>
                  <span className="text-gray-400 text-sm">Laura Sommerfeld Official</span>
                </div>
              </a>

              <a
                href={socialMedia.tiktok}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-black/50 border border-white/10 rounded-lg hover:border-cyan-400 hover:bg-cyan-500/10 transition-all duration-300 group"
              >
                <Music2 className="text-cyan-400 group-hover:scale-110 transition-transform" size={24} />
                <div>
                  <span className="text-white font-medium block">TikTok</span>
                  <span className="text-gray-400 text-sm">@laura.sommerfeld</span>
                </div>
              </a>

              <a
                href={socialMedia.youtube}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 p-4 bg-black/50 border border-white/10 rounded-lg hover:border-red-400 hover:bg-red-500/10 transition-all duration-300 group"
              >
                <Youtube className="text-red-400 group-hover:scale-110 transition-transform" size={24} />
                <div>
                  <span className="text-white font-medium block">YouTube</span>
                  <span className="text-gray-400 text-sm">Laura Sommerfeld</span>
                </div>
              </a>
            </div>

            {/* Info Box */}
            <div className="mt-8 p-4 bg-gradient-to-br from-blue-500/20 to-cyan-400/20 border border-blue-400/30 rounded-lg">
              <p className="text-gray-300 text-sm text-center">
                📧 Für geschäftliche Anfragen und Buchungen kontaktiere mich gerne über Instagram Direct Message.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactSection;
